import * as Yup from 'yup';
import { bankAccountSchema } from '../../bankAccountValidations';

export const compensationSchema = Yup.object()
  .shape({
    transferBank: Yup.object()
      .nullable()
      .required('validationErrors.isRequired'),
    transferAccount: Yup.string().when('transferType', (transferType, schema) => (transferType === 'account' ? schema.concat(bankAccountSchema) : schema)),
  });

export default compensationSchema;
